var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:twitter-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6385 8.1368C25.8097 8.50345 24.9308 8.74432 24.0309 8.85143C24.9791 8.28357 25.6885 7.39038 26.0271 6.33826C25.1365 6.86826 24.1601 7.2397 23.1435 7.44062C22.46 6.70924 21.5539 6.22418 20.5662 6.06086C19.5786 5.89754 18.5646 6.0651 17.682 6.5375C16.7993 7.0099 16.0975 7.76067 15.6856 8.67309C15.2737 9.58551 15.1748 10.6085 15.4042 11.5829C13.598 11.4925 11.831 11.0233 10.2179 10.2056C8.60483 9.38795 7.18178 8.24016 6.04114 6.83677C5.63743 7.53017 5.42529 8.31842 5.42642 9.12078C5.42642 10.6956 6.22903 12.0868 7.44652 12.9014C6.72538 12.8787 6.02012 12.6839 5.38949 12.3334V12.3888C5.38946 13.4378 5.75228 14.4545 6.41641 15.2665C7.08054 16.0785 8.0051 16.6358 9.03327 16.8439C8.36386 17.0255 7.66188 17.0522 6.98059 16.922C7.27049 17.825 7.83557 18.6147 8.59667 19.1804C9.35777 19.7462 10.2768 20.0597 11.225 20.0771C10.2826 20.8172 9.20366 21.3643 8.04973 21.6871C6.8958 22.0098 5.68956 22.102 4.5 21.9582C6.57627 23.2934 8.9932 24.0022 11.4617 24C19.818 24 24.386 17.0784 24.386 11.0757C24.386 10.8802 24.3817 10.6826 24.373 10.4881C25.2618 9.84558 26.029 9.04862 26.6385 8.1368Z",
    fill: "#FFDCA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSvg);
export default __webpack_public_path__ + "static/media/TwitterSVG.0ae499ea5ac580dba8dfcedb9408d3e9.svg";
export { ForwardRef as ReactComponent };